module.exports = __webpack_public_path__ + "static/media/trash.ce4e7849.svg";